import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { UitkToast } from 'uitk-react-toast';
import { UIPageStore } from 'stores/ui-page-store';

export interface NotificationProps {
  uiPage?: UIPageStore;
}

@inject('uiPage')
@observer
export class Notification extends React.Component<NotificationProps> {
  constructor(props) {
    super(props);
  }

  public componentWillUnmount() {
    this.props.uiPage.resetNotification();
  }

  public render() {
    const { uiPage } = this.props;

    if (!uiPage || !uiPage.notifications) {
      return null;
    }

    return (
      <React.Fragment>
        {uiPage.notifications.show && <UitkToast show={uiPage.notifications.show}>{uiPage.notifications.message}</UitkToast>}
      </React.Fragment>
    );
  }
}
